var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CFEBCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#CFEBCE",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9247 43.6499L43.8219 43.3819L41.0251 48.1129C40.7434 48.5893 40.3864 48.852 40.0193 48.852C39.6479 48.852 39.2907 48.5832 39.0136 48.095L36.3297 43.3687L31.0747 43.6499C29.6697 43.7233 28.0082 44.2858 27.2925 44.9303C26.5677 45.5827 26 47.2058 26 48.6258V50.2015C26 51.6716 27.1967 52.8681 28.6667 52.8681H51.3333C52.8035 52.8681 54 51.6716 54 50.2015V48.6258C54 47.2058 53.4323 45.5827 52.7074 44.9303C51.9905 44.2863 50.3295 43.7238 48.9247 43.6499Z",
    fill: "#00848D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5113 47.3981C39.7251 47.8895 40.1028 47.9037 40.354 47.4307L41.2084 45.8222L40.2216 44.7683L40.9693 43.9918L39.9996 43.418L39.0503 43.9634L39.7742 44.7527L38.788 45.7409L39.5113 47.3981Z",
    fill: "#00848D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1208 27.1318C35.9768 27.1318 32.6057 30.5031 32.6057 34.647C32.6057 38.7909 35.9768 42.1622 40.1208 42.1622C42.4816 42.1622 44.5886 41.0656 45.9679 39.3582L51.2965 43.1674C51.9499 43.6342 52.7704 43.4307 53.1298 42.712L53.7245 41.5202C54.0829 40.8015 53.7538 40.0192 52.9896 39.7731L47.1871 37.182C47.4725 36.3882 47.6364 35.5373 47.6364 34.6472C47.6359 30.5031 44.2648 27.1318 40.1208 27.1318ZM40.1208 40.2228C37.0465 40.2228 34.545 37.7215 34.545 34.647C34.545 31.5727 37.0464 29.0712 40.1208 29.0712C43.1952 29.0712 45.6966 31.5726 45.6966 34.647C45.6965 37.7215 43.1952 40.2228 40.1208 40.2228Z",
    fill: "#00848D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1208 29.8804C37.4924 29.8804 35.3542 32.0186 35.3542 34.6469C35.3542 34.7807 35.4628 34.8893 35.5966 34.8893C35.7304 34.8893 35.839 34.7807 35.839 34.6469C35.839 32.2861 37.7594 30.3653 40.1208 30.3653C40.2545 30.3653 40.3632 30.2566 40.3632 30.1229C40.3632 29.9891 40.2545 29.8804 40.1208 29.8804Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPro);
export default __webpack_public_path__ + "static/media/searchPro.c0216076795ef62d660075546a85b366.svg";
export { ForwardRef as ReactComponent };